import * as Yup from "yup";

export const SignInScheme = Yup.object().shape({
  login: Yup.string().required("Please enter your email or phone number")
});